(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.hh-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  function initRails(root) {
    (root || document).querySelectorAll('[data-hh-rail]').forEach(function (rail) {
      var wrap = rail.parentElement;
      var prev = wrap.querySelector('[data-hh-prev]');
      var next = wrap.querySelector('[data-hh-next]');
      var step = function () { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; };
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { var v = e.target.querySelector('video'); if (!v) return; if (e.isIntersecting) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } });
        }, { threshold: 0.4 });
        rail.querySelectorAll('.hh-media').forEach(function (m) { vio.observe(m); });
      }
    });
  }
  function init(root) { initReveal(root); initRails(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); e.target.querySelectorAll('.hh-reveal').forEach(function (el) { el.classList.add('is-in'); }); });
})();

/* Koszyk: „Rabaty zarezerwowane przez następne 15 minut” – liczy od dodania do koszyka, nie resetuje się po odświeżeniu */
(function () {
  var MS = 15 * 60 * 1000, KS = 'hhResStart', KC = 'hhResCount';
  var get = function (k) { try { return Number(localStorage.getItem(k)) || 0; } catch (e) { return 0; } };
  var put = function (k, v) { try { localStorage.setItem(k, String(v)); } catch (e) {} };
  var del = function (k) { try { localStorage.removeItem(k); } catch (e) {} };
  var tick = function () {
    var boxes = document.querySelectorAll('[data-hh-res]');
    if (!boxes.length) return;
    var count = Number(boxes[0].dataset.count) || 0;
    var now = Date.now(), start = get(KS), prev = get(KC);
    if (count === 0) { del(KS); del(KC); return; }
    // start przy pierwszym dodaniu; nowy start, gdy czas minął, a klient dorzucił coś do koszyka
    if (!start || (count > prev && now - start >= MS)) { start = now; put(KS, start); }
    if (count !== prev) put(KC, count);
    var left = Math.max(0, MS - (now - start));
    var s = Math.ceil(left / 1000), txt = Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
    boxes.forEach(function (b) {
      var t = b.querySelector('[data-hh-res-left]'); if (t && t.textContent !== txt) t.textContent = txt;
      var bar = b.querySelector('[data-hh-res-bar]'); if (bar) bar.style.width = (left / MS * 100).toFixed(2) + '%';
      b.classList.toggle('is-low', left < 3 * 60 * 1000);
    });
  };
  tick();
  setInterval(tick, 1000);
})();

/* Zapis na newsletter bez przeładowania strony + powiadomienie */
(function () {
  if (window.__hhSignup) return; window.__hhSignup = true;
  var toast = function (ok, text) {
    var old = document.querySelector('.hh-toast'); if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'hh-toast' + (ok ? '' : ' hh-toast--err');
    t.setAttribute('role', ok ? 'status' : 'alert');
    t.innerHTML = '<span class="hh-toast__ico" aria-hidden="true">' + (ok ? '✓' : '!') + '</span><span class="hh-toast__txt"></span><button type="button" class="hh-toast__x" aria-label="Zamknij">×</button>';
    t.querySelector('.hh-toast__txt').innerHTML = text;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    var hide = function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 400); };
    t.querySelector('.hh-toast__x').addEventListener('click', hide);
    setTimeout(hide, 6000);
  };
  window.hhToast = toast;
  // komunikat po zwykłym wysłaniu (np. po stronie antyspamowej Shopify)
  var onLoad = function () {
    if (/customer_posted=true/.test(location.search)) {
      toast(true, '<b>Zapis udany!</b> Dzięki – jako pierwszy dowiesz się o rabatach i nowościach.');
      return;
    }
    var err = document.querySelector('form.email-signup__form [id^="Email-signup__message-error"]');
    if (err) {
      var msg = (err.textContent || '').trim();
      if (/zaj|taken|istnieje|already/i.test(msg)) toast(true, '<b>Ten e-mail jest już zapisany ✓</b> Rabaty i nowości dostaniesz na skrzynkę.');
      else toast(false, msg || 'Sprawdź adres e-mail i spróbuj jeszcze raz.');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(onLoad, 500); }); else setTimeout(onLoad, 500);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form.email-signup__form') || f.dataset.hhNative) return;
    // Najpierw ochrona antyspamowa Shopify (hCaptcha): bez tokena nic nie wysyłamy, Shopify sam dokończy i wyśle ponownie
    if (e.defaultPrevented) return;
    var tok = f.querySelector('[name="h-captcha-response"], [name="g-recaptcha-response"]');
    if (!tok || !tok.value) return;
    e.preventDefault();
    var btn = f.querySelector('button'); if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) {
        // Shopify czasem prosi o weryfikację antyspamową – wtedy wysyłamy normalnie
        if (/\/challenge/.test(r.url)) { f.dataset.hhNative = '1'; f.submit(); return; }
        return r.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var err = doc.querySelector('[id^="Email-signup__message-error"]');
          var ok = /customer_posted=true/.test(r.url) || doc.querySelector('[id^="Email-signup__message-success"]');
          if (ok && !err) {
            toast(true, '<b>Zapis udany!</b> Dzięki – jako pierwszy dowiesz się o rabatach i nowościach.');
            f.reset();
          } else if (err) {
            var msg = (err.textContent || '').trim();
            if (/zaj|taken|istnieje|already/i.test(msg)) toast(true, '<b>Ten e-mail jest już zapisany ✓</b> Rabaty i nowości dostaniesz na skrzynkę.');
            else toast(false, msg ? msg : 'Sprawdź adres e-mail i spróbuj jeszcze raz.');
          } else {
            f.dataset.hhNative = '1'; f.submit();
          }
        });
      })
      .catch(function () { f.dataset.hhNative = '1'; f.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  });
})();
